/**
 * Единые подписи для schedule_type (мастер-карта, Gantt, экспорт).
 * ТЗ: preconstruction = «до начала строительства», tz_construction = «строительство» на вкладке ТЗ.
 */

export const SCHEDULE_DEPARTMENT_LABELS = {
  document: 'Тех. заказчик',
  hr: 'HR',
  procurement: 'Закупки',
  construction: 'Строительство',
  marketing: 'Маркетинг',
  preconstruction: 'До начала строительства',
  tz_construction: 'Строительство (ТЗ)',
};

export const GANTT_DEPARTMENT_OPTIONS = [
  { key: 'document', label: 'Тех. заказчик' },
  { key: 'hr', label: 'HR' },
  { key: 'procurement', label: 'Закупки' },
  { key: 'construction', label: 'Строительство' },
  { key: 'marketing', label: 'Маркетинг' },
  { key: 'preconstruction', label: 'До начала строительства' },
  { key: 'tz_construction', label: 'Строительство (ТЗ)' },
];

export const GANTT_TYPE_COLORS = {
  document: { bg: '#7b9eb8', border: '#5a7d96' },
  hr: { bg: '#a99bc4', border: '#8677a3' },
  procurement: { bg: '#d4b896', border: '#b89b73' },
  construction: { bg: '#8bc49a', border: '#69a378' },
  marketing: { bg: '#d4a0b8', border: '#b87d9a' },
  preconstruction: { bg: '#7baeb8', border: '#5a8d96' },
  tz_construction: { bg: '#8bc49a', border: '#5a9a6a' },
};

export function isTzScheduleType(scheduleType) {
  return scheduleType === 'preconstruction' || scheduleType === 'tz_construction';
}

/** Название отдела / графика для таблиц и легенды */
export function getScheduleDepartmentLabel(scheduleType) {
  return SCHEDULE_DEPARTMENT_LABELS[scheduleType] || scheduleType || '—';
}

/**
 * Колонка «Этап»: для ТЗ — sections (этап строительства), не № п/п (construction_stage).
 */
export function getScheduleStageLabel(schedule) {
  if (!schedule) return '—';
  const type = schedule.schedule_type;
  if (type === 'preconstruction' || type === 'tz_construction') {
    const stage = (schedule.sections || '').trim();
    if (stage) return stage;
    return type === 'preconstruction' ? 'До начала строительства' : 'Строительство (ТЗ)';
  }
  return (schedule.construction_stage || schedule.sections || '').trim() || 'Без этапа';
}

/** Детали строки для мастер-карты */
export function getScheduleDetailInfo(schedule) {
  if (!schedule) return '';
  const type = schedule.schedule_type;
  if (type === 'document') return schedule.sections || '';
  if (type === 'hr') return schedule.vacancy || '';
  if (isTzScheduleType(type)) return schedule.work_name || '';
  if (['procurement', 'construction', 'marketing'].includes(type)) {
    return schedule.work_name || '';
  }
  return schedule.work_name || schedule.vacancy || schedule.sections || '';
}

export function getScheduleDetailFieldName(scheduleType) {
  if (scheduleType === 'document') return 'Разделы';
  if (scheduleType === 'hr') return 'Вакансия';
  if (isTzScheduleType(scheduleType)) return 'Наименование работ';
  if (['procurement', 'construction', 'marketing'].includes(scheduleType)) {
    return 'Наименование работ';
  }
  return 'Информация';
}

/** Подпись работы в сайдбаре Gantt */
export function getScheduleWorkLabel(schedule) {
  if (!schedule) return 'Без названия';
  if (isTzScheduleType(schedule.schedule_type)) {
    return schedule.work_name || schedule.vacancy || 'Без названия';
  }
  return schedule.work_name || schedule.vacancy || schedule.sections || 'Без названия';
}
